import template from './expenses.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    expenses: '<',
    isPurchaseOwnerOccupied: '<',
    isShortVersion: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
controller: class controller {
    constructor($rootScope, $mdUtil, expensesService, helperService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availablePaymentFrequencies = [];
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().cca2;
        ctrl.availablePaymentFrequencies = helperService.getAvailablePaymentFrequencies({
          isExpense: true
        });
        ctrl.expenses = ctrl.expenses || {};
        ctrl.isPurchaseOwnerOccupied = ctrl.isPurchaseOwnerOccupied || false;
        ctrl.isShortVersion = ctrl.isShortVersion || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isReady = true;
      };

      ctrl.totalFoodExpenses = () =>
        expensesService.getTotalFoodExpenses(ctrl.expenses, ctrl.isShortVersion);

      ctrl.totalDiscretionaryExpenses = () =>
        expensesService.getTotalDiscretionaryExpenses(ctrl.expenses, ctrl.isShortVersion);

      ctrl.totalChildrenAndEducationExpenses = () =>
        expensesService.getTotalChildrenAndEducationExpenses(
          ctrl.expenses,
          ctrl.isShortVersion
        );

      ctrl.totalHealthAndWellnessExpenses = () =>
        expensesService.getTotalHealthAndWellnessExpenses(ctrl.expenses, ctrl.isShortVersion);

      ctrl.totalTransportationExpenses = () =>
        expensesService.getTotalTransportationExpenses(ctrl.expenses, ctrl.isShortVersion);

      ctrl.totalPropertyExpenses = () =>
        expensesService.getTotalPropertyExpenses(
          ctrl.expenses,
          ctrl.isShortVersion,
          ctrl.isPurchaseOwnerOccupied
        );

      ctrl.totalExpenses = () =>
        expensesService.getTotalExpenses(
          ctrl.expenses,
          ctrl.isShortVersion,
          ctrl.isPurchaseOwnerOccupied
        );

      /*
       * Save expenses
       * --------------------------------------------------------------------------------
       */
      ctrl.saveExpenses = $mdUtil.debounce(() => {
        ctrl.onFinished({ expenses: ctrl.expenses });
      }, 1500);

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
